import type { PaddleAuthConnectRequestPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../../services/api';

export function usePaddleConnect(
  options?: UseMutationOptions<void, unknown, PaddleAuthConnectRequestPayload>,
) {
  return useMutation((paddleConnectRequest) => {
    const api = getPrivateApi();

    return api.paddleConnect({ paddleConnectRequest });
  }, options);
}
